import NewHeader from "./newHeader/newHeader";
import SearchBox from "./searchBox/searchBox";
import InfoBlocks from "./infoBlocks/infoBlocks";

import NewFooter from "./newFooter/newFooter";
import { useState } from "react";

import NewBrokerTable from "./table/NewBrokerTable";
import { newFetchBrokers } from "./Api";

const NewMain = () => {
  const [searchValue, setSearchValue] = useState("");
  const [tableData, setTabledata] = useState(null);
  const [validationError, setValidationError] = useState(null);

  const onSubmit = async () => {
    if (searchValue.length === 9) {
      const response = await newFetchBrokers(searchValue);
      setTabledata(response.data);
    } else {
      setValidationError(true);
    }
  };

  return (
    <>
      <div className="app_content">
        <NewHeader title={document.title} headingLevel="h1" />
        <SearchBox
          setSearchValue={setSearchValue}
          onSubmit={onSubmit}
          validationError={validationError}
          setValidationError={setValidationError}
        />

        {tableData != null ? (
          tableData.length > 0 ? (
            <NewBrokerTable tableData={tableData[0]} /> //Use first since backend returns array, but we always only show one
          ) : (
            <p
              className="body-lg"
              style={{ textAlign: "center", marginTop: "16px" }}
            >
              Ei tuloksia
            </p>
          )
        ) : (
          <>
            <InfoBlocks />
            <div
              style={{
                backgroundColor: "#EAECE2",
                padding: "24px",
                borderRadius: "4px",
                fontFamily: "Arial",
                fontSize: "16px",
                marginTop: "30px",
              }}
            >
              <div style={{ maxWidth: "768px", margin: "auto" }}>
                <p className="body-lg">
                  Rekisteri kiinteistönvälitysliikkeistä ja vuokrahuoneistojen
                  välitysliikkeistä on julkinen ja jokaisella on oikeus saada
                  siitä tietoja.
                </p>
                <p className="body-lg">
                  Välitysliikerekisteri sisältää henkilötietoja. Henkilötietojen
                  suojaamiseksi Lupa- ja valvontavirasto ei julkaise koko rekisterin
                  tietoja yleisölle tarjottavan katseluyhteyden välityksellä.
                  Voit kuitenkin hakea verkkosivulta yrityksen yritys- ja
                  yhteisötunnuksella (y-tunnus) tiedon siitä, onko kyseinen
                  yritys (yksityinen elinkeinonharjoittaja tai oikeushenkilö)
                  rekisteröitynyt välitysliikerekisteriin. Jos yritys on
                  rekisteröitynyt välitysliikerekisteriin, saat myös tiedon
                  siitä, onko se rekisteröity kiinteistönvälitysliikkeeksi vai
                  vuokrahuoneiston välitysliikkeeksi. Tarvittaessa saat selville
                  tietyn yrityksen y-tunnuksen yritys- ja
                  yhteisötietojärjestelmästä:{" "}
                  <a href="https://ytj.fi">
                    ytj.fi
                  </a>
                  .
                </p>
                <p className="body-lg">
                  Muita välitysliikerekisterin tietoja voit tiedustella
                  <a href="https://lvv.fi/asiakaspalvelu" style={{marginLeft: "3px"}}>
                    Lupa- ja valvontaviraston asiakaspalvelusta.
                  </a>
                </p>
              </div>
            </div>
          </>
        )}
      </div>
      <NewFooter />
    </>
  );
};

export default NewMain;
